import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { CuisineType, FoodType } from "@/types/recipe";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface BasicInfoSectionProps {
  title: string;
  setTitle: (title: string) => void;
  description: string;
  setDescription: (description: string) => void;
  cuisineType: CuisineType | '';
  setCuisineType: (type: CuisineType | '') => void;
  foodType: FoodType | '';
  setFoodType: (type: FoodType | '') => void;
  servings: number;
  setServings: (servings: number) => void;
}

export const BasicInfoSection = ({
  title,
  setTitle,
  description,
  setDescription,
  cuisineType,
  setCuisineType,
  foodType,
  setFoodType,
  servings,
  setServings,
}: BasicInfoSectionProps) => {
  const cuisineTypes: CuisineType[] = [
    'Italian', 'Lebanese', 'Greek', 'Indian', 'Chinese', 'Japanese',
    'Thai', 'Mexican', 'French', 'Spanish', 'American', 'Mediterranean',
    'Middle Eastern', 'Korean', 'Vietnamese', 'Turkish', 'Brazilian',
    'Caribbean', 'African', 'Other'
  ];

  const foodTypes: FoodType[] = [
    'Chicken', 'Dessert', 'Snacks', 'Vegetables',
    'Ground Beef', 'Seafood', 'Soup', 'Pork', 'Other'
  ];

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="title">Recipe Title</Label>
        <Input
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter recipe title"
          className="w-full"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="servings">Number of Servings</Label>
        <Input
          id="servings"
          type="number"
          min="1"
          value={servings}
          onChange={(e) => setServings(Math.max(1, parseInt(e.target.value) || 1))}
          placeholder="Enter number of servings"
          className="w-full"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="cuisineType">Cuisine Type</Label>
        <Select value={cuisineType} onValueChange={(value) => setCuisineType(value as CuisineType)}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a cuisine type" />
          </SelectTrigger>
          <SelectContent>
            {cuisineTypes.map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="foodType">Food Type</Label>
        <Select value={foodType} onValueChange={(value) => setFoodType(value as FoodType)}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a food type" />
          </SelectTrigger>
          <SelectContent>
            {foodTypes.map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Share the story behind this recipe or add a brief introduction..."
          className="w-full min-h-[100px]"
        />
      </div>
    </>
  );
};
